import { Building2, ChevronRight, Plus } from 'lucide-react';
import { Link, useNavigate } from 'react-router';
import { api } from '../api';
import { Avatar, EmptyState, Loading, Notice, PageHeader, Pill } from '../components/ui';
import { t } from '../i18n';
import { useLoad } from '../lib/hooks';

export function Tenants() {
  const tenants = useLoad(api.platform.listTenants);
  const navigate = useNavigate();
  return (
    <div className="stack">
      <PageHeader title={t('Tenants')} description={t('Each tenant is a company with its own name, hostname, people and phone numbers.')}>
        <Link className="button" to="/tenants/new" data-testid="new-tenant">
          <Plus size={16} aria-hidden /> {t('New tenant')}
        </Link>
      </PageHeader>
      {tenants.error && <Notice kind="error">{tenants.error}</Notice>}
      {!tenants.data ? (
        <Loading />
      ) : tenants.data.length === 0 ? (
        <div className="card">
          <EmptyState icon={Building2} title={t('No tenants yet')}>
            <p>{t('Create the first one, starting with your own company.')}</p>
          </EmptyState>
        </div>
      ) : (
        <div className="card table-wrap">
          <table>
            <thead>
              <tr>
                <th>{t('Tenant')}</th>
                <th className="hide-mobile">{t('Hostname')}</th>
                <th>{t('People')}</th>
                <th>{t('Status')}</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {tenants.data.map((tenant) => (
                <tr key={tenant.id} data-testid="tenant-row" onClick={() => void navigate(`/tenants/${tenant.id}`)} style={{ cursor: 'pointer' }}>
                  <td>
                    <div className="person">
                      <Avatar name={tenant.productName} square />
                      <div>
                        <Link className="name" to={`/tenants/${tenant.id}`} onClick={(e) => e.stopPropagation()}>
                          {tenant.name}
                        </Link>
                        <div className="detail">{tenant.productName}</div>
                      </div>
                    </div>
                  </td>
                  <td className="hide-mobile mono muted">{tenant.hostname}</td>
                  <td className="tabular">{tenant.userCount}</td>
                  <td>
                    {tenant.status === 'ACTIVE' ? (
                      <Pill kind="success" dot>
                        {t('Active')}
                      </Pill>
                    ) : (
                      <Pill kind="warning" dot>
                        {t('Suspended')}
                      </Pill>
                    )}
                  </td>
                  <td className="actions">
                    <ChevronRight size={18} className="subtle" aria-hidden />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
